import React from 'react';
import './Total.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons';

interface TotalProps {
  count: number;
  isActive?: boolean;
}

const Total: React.FC<TotalProps> = ({ count, isActive = false }) => {
  return (
    <div className={`table-task-total-container ${isActive ? 'active' : ''}`}>
      <span className="data-bar-icon total">
        <FontAwesomeIcon icon={faClipboardList} />
      </span>
      <span className="table-task-total-label">Total Tasks</span>
      <span className="table-task-total-count">{count}</span>
    </div>
  );
};

export default Total;
